import { Injectable } from '@angular/core';
import { AngularFireDatabase } from "angularfire2/database";


@Injectable()
export class FireService {

  constructor(private afDb: AngularFireDatabase) { }

  getQuotes(cb) {
    this.afDb.list('quotes').valueChanges().subscribe(items => cb(items));
  }

  getEducationDetails(cb) {
    this.afDb.list('education').valueChanges().subscribe(items => cb(items));
  }

  getExperienceDetails(cb) {
    this.afDb.list('experience').valueChanges().subscribe(items => cb(items));
  }

  getProjects(cb) {
    this.afDb.list('projects').valueChanges().subscribe(items => cb(items));
  }

  getSkills(cb) {
    this.afDb.list('skills').valueChanges().subscribe(items => cb(items));
  }
}



// WEBPACK FOOTER //
// F:/Home/Locker/About-me/about-me1/src/app/fire.service.ts